export default "__VITE_ASSET__Du8p8xlg__"